import type { ReactNode } from 'react'

import clsx from 'clsx'

import { Button } from '@/shared/ui/Button'

type ResourceAdvancedFilterPanelProps = {
  title: string
  clearLabel: string
  hasActiveFilters: boolean
  onReset: () => void
  children: ReactNode
  className?: string
}

/** Corpo do painel de filtros avançados — popover (desktop) ou sheet (mobile). */
export const ResourceAdvancedFilterPanel = ({
  title,
  clearLabel,
  hasActiveFilters,
  onReset,
  children,
  className
}: ResourceAdvancedFilterPanelProps) => (
  <div className={clsx('flex flex-col gap-4', className)}>
    <h3 className="m-0 text-base font-bold leading-tight text-gray-900">{title}</h3>
    <div className="flex flex-col gap-4">{children}</div>
    {hasActiveFilters && (
      <Button
        type="button"
        variant="light"
        size="md"
        className="w-full"
        onClick={onReset}
        showTrailingIcon={false}
      >
        {clearLabel}
      </Button>
    )}
  </div>
)

ResourceAdvancedFilterPanel.displayName = 'ResourceAdvancedFilterPanel'
